import { FaEllipsisH } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { BsShare } from "react-icons/bs";
import VideoGuide from "./video-guide";
import Button from "components/button/button";
import { FaRegTrashAlt } from "react-icons/fa";
import { LiaEditSolid } from "react-icons/lia";
import { motion, AnimatePresence } from "framer-motion";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import { IoCogSharp  } from "react-icons/io5";
import { onboarding_SUCCESS_VIDEO } from "utils/constant";

const noop = ()=>{}

const TutorialVid = ({ hide, position, parent, count = 1 ,
         onEdit = noop, quickEditId =null, onDelete = noop,
         onShare = noop, onQuickEdit=noop}) => {
    const { left,top } = position || {};
    const {height=0 } = parent;
    const { t } = useTranslation();
    return (
        <AnimatePresence>
            {(left && height) && (
                <div
                    className="fixed z-[500] inset-0 modal-animation"
                    aria-labelledby="modal-title"
                    role="dialog"
                    aria-modal="true"
                >
                    <div
                        className="fixed inset-0 bg-black bg-opacity-70 transition-opacity"
                        aria-hidden="true"
                    />
                    <motion.div
                        initial={{ opacity: 0, scale: 0.60 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.60 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        className="absolute right-4 top-[10px] 7sm:top-[190px] 2sm:left-[unset] 2sm:top-[unset]"
                        style={{
                            ...(window.innerWidth >= 515 && 
                                { left: `${left - 650}px` ,
                                top: `${count >= 2 ? (top - height) - 160 : (top - 810)}px`
                            }) // only apply calc left in desktop
                        }}
                    >
                        <div className="flex bg-transparent gap-2 2sm:gap-10 relative flex-col 2sm:flex-row">
                            <div className="px-8 py-4 bg-[#f5f5f5] rounded-md w-[20rem] 2sm:w-[25rem] h-[26.5rem] relative">
                                <div className="hidden 2sm:block absolute z-0 -right-[1rem] top-[28px] w-10 h-10 bg-[#f5f5f5] rotate-45"></div>
                                <div className="flex justify-between items-center">
                                    <h2 className="font-semibold  text-base 2sm:text-lg">
                                        Edit, Share, or Delete a Milestone
                                    </h2>
                                    <span className="close" onClick={() => hide()}></span>
                                </div>
                                
                                <p className="text-xs 2sm:text-base">
                                    Quick tweak, send, or remove milestones whenever you need.
                                </p>
                                <VideoGuide className="w-auto h-[70%]" vidLink={onboarding_SUCCESS_VIDEO}/>
                                <Button
                                    onClick={hide}
                                    buttonName={"Got it"}
                                    buttonClass="py-2 px-4 bg-gray w-full mt-2"
                                    buttonTextClass="text-black text-sm font-semibold flex items-center justify-center"
                                />
                            </div>
                            <div className="bg-transparent">
                                <div className="px-6 py-3 bg-[#f5f5f5] rounded-md">
                                    <div className="w-full flex justify-end mb-2 ">
                                        <div className="bg-white w-6 h-6 2sm:w-10 2sm:h-10 rounded-md inline flex items-center justify-center cursor-text">
                                            <FaEllipsisH className="text-1xs 2sm:text-base" />
                                        </div>
                                    </div>
                                    <div className="flex flex-col shadow-lg rounded-md bg-white">
                                        <ul>
                                            <li className="">
                                                <button className="flex flex-row items-center text-base 2sm:text-lg px-6 py-2 cursor-pointer" onClick={onQuickEdit}>
                                                    <HiOutlinePencilSquare className="mr-3" />
                                                    {t("quickEditMode")}
                                                </button>
                                            </li>
                                            <li className="">
                                                <button className="flex flex-row items-center text-base 2sm:text-lg px-6 py-2 cursor-pointer" onClick={onEdit}>
                                                    <IoCogSharp className="mr-3" />
                                                    {t("advancedEdit")}
                                                </button>
                                            </li>
                                            <li className="">
                                                <button className="flex flex-row items-center text-base 2sm:text-lg px-6 py-2 cursor-pointer" onClick={onShare}>
                                                    <BsShare className="mr-3" />
                                                    {t("shareMilestone")}
                                                </button>
                                            </li>
                                            <li className="">
                                                <button className="flex flex-row items-center text-base 2sm:text-lg px-6 py-2 text-danger cursor-pointer" onClick={onDelete}>
                                                    <FaRegTrashAlt className="mr-3" />
                                                    {t("deleteMilestone")}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};


export default TutorialVid;